import React, { useEffect, useState } from "react";
import Filter from "./Filter";
import Table from "./Table";
import "./Parent.css";
import Add_User from "./Add";
import Edit_User from "./Edit";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import { FixIDS } from "../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

const Material_Tested = () => {
  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null); // Track which user to edit
  const [searchName, setSearchName] = useState("");
  const [success, setSuccess] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(FixIDS.material_tested.List);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="User Roles">
      <div className="filter_div">
        <Filter setAdd={setAdd} setSearchName={setSearchName} />
      </div>

      <div className="sample_table_div">
        {havePermission && (
          <Table
            setEdit={setEdit}
            setEditId={setEditId}
            searchName={searchName} // pass the selected user id
          />
        )}
      </div>

      <Add_User
        setSuccess={setSuccess}
        show={add}
        setShow={setAdd}
        handleClose={() => setAdd(false)}
      />

      <Edit_User
        setSuccess={setSuccess}
        show={edit}
        id={editId}
        setShow={setEdit}
        handleClose={() => setEdit(false)}
      />
      {success && <Success_Toster successText="Data Save successfully!" />}
    </section>
  );
};

export default Material_Tested;
